import * as Types from '../../../../types.generated';

import { gql } from '@apollo/client';
import { TrainingResourceVersionFragmentDoc, MediaFragmentDoc } from '../../../../fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddMediaDialogTrainingResourcesQueryVariables = Types.Exact<{
  search: Types.Scalars['String']['input'];
}>;


export type AddMediaDialogTrainingResourcesQuery = { __typename?: 'Query', TrainingResources: Array<{ __typename?: 'TrainingResource', id: string, publishedVersion?: { __typename?: 'TrainingResourceVersion', id: string, type: Types.TrainingResourceVersionType, richTextDocument?: { __typename?: 'RichTextDocument', id: string, content: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } } | null, media?: { __typename?: 'Media', id: number, loopVideo: boolean, hideVideoControls: boolean, unoptimizedUrl?: string | null, createdAt: string, updatedAt: string, thumbnailImageUrl?: string | null, mostRecentConvertMediaToRichTextDocumentWorkflow?: { __typename?: 'ConvertMediaToRichTextDocumentWorkflow', id: string, conversionStatus?: { __typename?: 'MediaConversionStatus', id: string, failedAt?: string | null, succeededAt?: string | null } | null, richTextDocuments?: Array<{ __typename?: 'RichTextDocument', id: string }> | null } | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null, trainingResourceVersions?: Array<{ __typename?: 'TrainingResourceVersion', id: string, trainingResource: { __typename?: 'TrainingResource', id: string, libraryItem: { __typename?: 'LibraryItem', id: string, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } } } }> | null } | null, trainingResource: { __typename?: 'TrainingResource', id: string, lastBuilderActionId?: number | null, draftVersion: { __typename?: 'TrainingResourceVersion', id: string }, publishedVersion?: { __typename?: 'TrainingResourceVersion', id: string } | null, libraryItem: { __typename?: 'LibraryItem', id: string, publishState?: Types.PublishState | null, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, description: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, qrCode?: { __typename?: 'ContentQRCode', id: string, includeLogo: boolean, includeTitle: boolean, isActive: boolean, imageUrl: string, destinationUrl: string } | null } } } | null }> };

export type AddMediaDialogCreateMediaMutationVariables = Types.Exact<{
  input: Types.MediaInput;
}>;


export type AddMediaDialogCreateMediaMutation = { __typename?: 'Mutation', createMedia: { __typename?: 'MediaMutationResult', success: boolean, error?: { __typename?: 'Error', code: string } | null, media?: { __typename?: 'Media', id: number, loopVideo: boolean, hideVideoControls: boolean, unoptimizedUrl?: string | null, createdAt: string, updatedAt: string, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null, trainingResourceVersions?: Array<{ __typename?: 'TrainingResourceVersion', id: string, trainingResource: { __typename?: 'TrainingResource', id: string, libraryItem: { __typename?: 'LibraryItem', id: string, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } } } }> | null } | null } };

export type GenerateImageMutationVariables = Types.Exact<{
  input: Types.GenerateImageInput;
}>;


export type GenerateImageMutation = { __typename?: 'Mutation', generateImage: { __typename?: 'ImageGenerationMutationResult', success: boolean, imageUrl?: string | null, error?: { __typename?: 'Error', code: string } | null } };


export const AddMediaDialogTrainingResourcesDocument = gql`
    query AddMediaDialogTrainingResources($search: String!) {
  TrainingResources: AdminTrainingResources(search: $search) {
    id
    publishedVersion {
      ...TrainingResourceVersion
    }
  }
}
    ${TrainingResourceVersionFragmentDoc}`;

/**
 * __useAddMediaDialogTrainingResourcesQuery__
 *
 * To run a query within a React component, call `useAddMediaDialogTrainingResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddMediaDialogTrainingResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddMediaDialogTrainingResourcesQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAddMediaDialogTrainingResourcesQuery(baseOptions: Apollo.QueryHookOptions<AddMediaDialogTrainingResourcesQuery, AddMediaDialogTrainingResourcesQueryVariables> & ({ variables: AddMediaDialogTrainingResourcesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddMediaDialogTrainingResourcesQuery, AddMediaDialogTrainingResourcesQueryVariables>(AddMediaDialogTrainingResourcesDocument, options);
      }
export function useAddMediaDialogTrainingResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddMediaDialogTrainingResourcesQuery, AddMediaDialogTrainingResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddMediaDialogTrainingResourcesQuery, AddMediaDialogTrainingResourcesQueryVariables>(AddMediaDialogTrainingResourcesDocument, options);
        }
export type AddMediaDialogTrainingResourcesQueryHookResult = ReturnType<typeof useAddMediaDialogTrainingResourcesQuery>;
export type AddMediaDialogTrainingResourcesLazyQueryHookResult = ReturnType<typeof useAddMediaDialogTrainingResourcesLazyQuery>;
export type AddMediaDialogTrainingResourcesQueryResult = Apollo.QueryResult<AddMediaDialogTrainingResourcesQuery, AddMediaDialogTrainingResourcesQueryVariables>;
export const AddMediaDialogCreateMediaDocument = gql`
    mutation AddMediaDialogCreateMedia($input: MediaInput!) {
  createMedia(input: $input) {
    success
    error {
      code
    }
    media {
      ...Media
    }
  }
}
    ${MediaFragmentDoc}`;
export type AddMediaDialogCreateMediaMutationFn = Apollo.MutationFunction<AddMediaDialogCreateMediaMutation, AddMediaDialogCreateMediaMutationVariables>;

/**
 * __useAddMediaDialogCreateMediaMutation__
 *
 * To run a mutation, you first call `useAddMediaDialogCreateMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMediaDialogCreateMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMediaDialogCreateMediaMutation, { data, loading, error }] = useAddMediaDialogCreateMediaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMediaDialogCreateMediaMutation(baseOptions?: Apollo.MutationHookOptions<AddMediaDialogCreateMediaMutation, AddMediaDialogCreateMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMediaDialogCreateMediaMutation, AddMediaDialogCreateMediaMutationVariables>(AddMediaDialogCreateMediaDocument, options);
      }
export type AddMediaDialogCreateMediaMutationHookResult = ReturnType<typeof useAddMediaDialogCreateMediaMutation>;
export type AddMediaDialogCreateMediaMutationResult = Apollo.MutationResult<AddMediaDialogCreateMediaMutation>;
export type AddMediaDialogCreateMediaMutationOptions = Apollo.BaseMutationOptions<AddMediaDialogCreateMediaMutation, AddMediaDialogCreateMediaMutationVariables>;
export const GenerateImageDocument = gql`
    mutation GenerateImage($input: GenerateImageInput!) {
  generateImage(input: $input) {
    success
    imageUrl
    error {
      code
    }
  }
}
    `;
export type GenerateImageMutationFn = Apollo.MutationFunction<GenerateImageMutation, GenerateImageMutationVariables>;

/**
 * __useGenerateImageMutation__
 *
 * To run a mutation, you first call `useGenerateImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateImageMutation, { data, loading, error }] = useGenerateImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateImageMutation(baseOptions?: Apollo.MutationHookOptions<GenerateImageMutation, GenerateImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateImageMutation, GenerateImageMutationVariables>(GenerateImageDocument, options);
      }
export type GenerateImageMutationHookResult = ReturnType<typeof useGenerateImageMutation>;
export type GenerateImageMutationResult = Apollo.MutationResult<GenerateImageMutation>;
export type GenerateImageMutationOptions = Apollo.BaseMutationOptions<GenerateImageMutation, GenerateImageMutationVariables>;